import React, {useState, useEffect} from "react";
import {useTranslation} from "react-i18next";
import moment from "moment";

// Libs
import {Icon} from "@blueprintjs/core";

// Components
import DateInput from "./date-input";
import SelectInput from "./select-input";

const SwitchDateFilters = (props) => {
    const {
        isManualDateRange,
        setIsManualDateRange,
        predefinedValue,
        setPredefinedValue,
        fromValue,
        toValue,
        setFromValue,
        setToValue,
        setDateChanged
    } = props;

    // i18n
    const {t} = useTranslation();

    const dateSelectOptions = [{
        value: "thisMonth",
        label: t("common:filters.thisMonth")
    }, {
        value: "lastMonth",
        label: t("common:filters.lastMonth")
    }, {
        value: "last30Days",
        label: t("common:filters.last30Days")
    }];

    function calculateDate(value) {
        switch (value) {
            case "thisMonth":
                setFromValue(moment().startOf("month").format("YYYY-MM-DD"));
                setToValue(moment().endOf("month").format("YYYY-MM-DD"));
                break;
            case "lastMonth":
                setFromValue(moment().subtract(1, "months").startOf("month").format("YYYY-MM-DD"));
                setToValue(moment().subtract(1, "months").endOf("month").format("YYYY-MM-DD"));
                break;
            case "last30Days":
                setFromValue(moment().subtract(29, "days").format("YYYY-MM-DD"));
                setToValue(moment().format("YYYY-MM-DD"));
                break;
            default:
                setFromValue(moment().subtract(29, "days").format("YYYY-MM-DD"));
                setToValue(moment().format("YYYY-MM-DD"));
        }
    }

    // set date selected
    const [selectedDate, setSelectedDate] = useState(predefinedValue ? predefinedValue : dateSelectOptions[2].value);
    const selectedDateData = dateSelectOptions.find(dateOptions => dateOptions.value === selectedDate);

    // set date value option selected when switch to predefined range
    useEffect(() => {
        if (!isManualDateRange) {
            setSelectedDate(predefinedValue);
            calculateDate(predefinedValue);
        }
    }, [isManualDateRange]);

    return (
        <div style={{display: "flex"}}>
            <div
                style={{
                    display: "block",
                    margin: "auto",
                    marginRight: 15,
                    width: 20,
                    height: "100%",
                    position: "relative",
                    cursor: "pointer"
                }}
                onClick={() => {
                    setIsManualDateRange(!isManualDateRange);
                    setDateChanged(true);
                }}
                title={!!isManualDateRange ? t("common:filters.dateIconLabel.predefinedRange") : t("common:filters.dateIconLabel.manualRange")}
            >
                <Icon
                    icon={!!isManualDateRange ? "calendar" : "timeline-events"}
                    iconSize={20}
                    style={{
                        position: "absolute",
                        top: 0
                    }}
                />
            </div>
            {!!isManualDateRange ?
                <div style={{display: "flex"}}>
                    <DateInput
                        labelText={t("common:filters.fromDate")}
                        inputWrapperStyle={{marginRight: 15}}
                        value={fromValue !== null ? moment(fromValue) : fromValue}
                        onChange={(fromValue) => {
                            setFromValue(fromValue !== null ? moment(fromValue).format("YYYY-MM-DD") : fromValue);
                            setPredefinedValue("");
                            setDateChanged(true);
                            console.log(fromValue);
                        }}
                    />
                    <DateInput
                        labelText={t("common:filters.toDate")}
                        inputWrapperStyle={{marginRight: 15}}
                        value={toValue !== null ? moment(toValue) : toValue}
                        onChange={(toValue) => {
                            setToValue(toValue !== null ? moment(toValue).format("YYYY-MM-DD") : toValue);
                            setPredefinedValue("");
                            setDateChanged(true);
                        }}
                    />
                </div>
            :
                <SelectInput
                    options={dateSelectOptions}
                    label={t("common:filters.dateRange")}
                    onChange={(selectedDate) => {
                        setSelectedDate(selectedDate.value);
                        calculateDate(selectedDate.value);
                        setPredefinedValue(selectedDate.value);
                        setDateChanged(true);
                    }}
                    value={selectedDateData}
                    style={{marginRight: 15}}
                />
            }
        </div>
    );
}

export default SwitchDateFilters;